/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AsyncS3ScanRequest
 */
export interface AsyncS3ScanRequest {
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    bucket: string;
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    callbackUrl?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AsyncS3ScanRequest
     */
    callbackHeaders?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    traceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AsyncS3ScanRequest
     */
    customData?: string;
}

/**
 * Check if a given object implements the AsyncS3ScanRequest interface.
 */
export function instanceOfAsyncS3ScanRequest(value: object): value is AsyncS3ScanRequest {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function AsyncS3ScanRequestFromJSON(json: any): AsyncS3ScanRequest {
    return AsyncS3ScanRequestFromJSONTyped(json, false);
}

export function AsyncS3ScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsyncS3ScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': json['bucket'],
        'key': json['key'],
        'version': json['version'] == null ? undefined : json['version'],
        'callbackUrl': json['callback_url'] == null ? undefined : json['callback_url'],
        'callbackHeaders': json['callback_headers'] == null ? undefined : json['callback_headers'],
        'traceId': json['trace_id'] == null ? undefined : json['trace_id'],
        'customData': json['custom_data'] == null ? undefined : json['custom_data'],
    };
}

export function AsyncS3ScanRequestToJSON(json: any): AsyncS3ScanRequest {
    return AsyncS3ScanRequestToJSONTyped(json, false);
}

export function AsyncS3ScanRequestToJSONTyped(value?: AsyncS3ScanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'],
        'key': value['key'],
        'version': value['version'],
        'callback_url': value['callbackUrl'],
        'callback_headers': value['callbackHeaders'],
        'trace_id': value['traceId'],
        'custom_data': value['customData'],
    };
}

